/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @returns {Promise<import('@supabase/supabase-js').Session | null>}
 */
export async function getSession(supabase) {
  const { data } = await supabase.auth.getSession();
  return data.session ?? null;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 */
export async function signInWithGoogle(supabase) {
  const redirectTo = typeof window !== "undefined" ? `${window.location.origin}/` : undefined;
  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo,
      // Always show Google’s account picker so users can switch accounts after sign-out.
      queryParams: {
        prompt: "select_account",
      },
    },
  });
  if (error) throw error;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 */
export async function signOut(supabase) {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {(
 *   event: import('@supabase/supabase-js').AuthChangeEvent,
 *   session: import('@supabase/supabase-js').Session | null
 * ) => void} callback
 * @returns {() => void} unsubscribe
 */
export function onAuthStateChange(supabase, callback) {
  const { data } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session ?? null);
  });
  return () => data.subscription.unsubscribe();
}
